"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("./styles");
const LanguageSelector = ({ isHorizontal, languageProps, }) => {
    const { selectedLanguage, setSelectedLanguage, languageList } = languageProps;
    const Wrapper = ({ children }) => {
        return isHorizontal ? ((0, jsx_runtime_1.jsx)(styles_1.StyledLanguageSelector, { fullWidth: true, flexDirection: "row", justifyContent: "space-between", children: children })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children }));
    };
    return ((0, jsx_runtime_1.jsx)(Wrapper, { children: languageList === null || languageList === void 0 ? void 0 : languageList.map(({ label, value }, index) => ((0, jsx_runtime_1.jsx)(styles_1.StyledLanguageText, { variant: "body", size: "normal", ...{
                selectedLanguage: selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.value,
                index,
            }, onClick: () => setSelectedLanguage({ label, value }), role: "button", "aria-roledescription": `select ${label} language`, children: label }, value))) }));
};
exports.default = LanguageSelector;
//# sourceMappingURL=language-selector.js.map